import { useField } from 'formik';
import {
  Checkbox,
  FormGroup,
  Typography,
  FormControl,
  FormHelperText,
  FormControlLabel,
} from '@mui/material';

import { controlError } from 'utils';

import { Icon, CheckboxOnIcon } from '../icons';

export interface CheckboxFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  options: { label: string; value: string }[];
}

export const CheckboxField = ({
  name,
  label,
  options,
  required,
}: CheckboxFieldProps) => {
  const [field, meta, helpers] = useField<string[]>(name);
  const selectedValues = Array.isArray(field.value) ? field.value : [];
  const errorText = controlError(meta, name, label);

  return (
    <FormControl required={required} error={Boolean(errorText)}>
      {label && (
        <Typography
          component="div"
          className="text-graydark-primary flex items-center text-xs leading-4.5"
        >
          <span className="min-w-0 truncate">{label}</span>
          {required && <span className="text-red-primary-primary"> *</span>}
        </Typography>
      )}
      <FormGroup>
        {options.map((option) => {
          const checked = selectedValues.includes(option.value);

          return (
            <FormControlLabel
              key={option.value}
              sx={{ padding: 0 }}
              label={option.label}
              control={
                <Checkbox
                  checked={checked}
                  icon={<Icon.CheckboxOff />}
                  checkedIcon={<CheckboxOnIcon />}
                  onChange={(event) => {
                    const nextValue = event.target.checked
                      ? [...selectedValues, option.value]
                      : selectedValues.filter(
                          (value) => value !== option.value
                        );

                    helpers.setValue(nextValue, true);
                  }}
                />
              }
            />
          );
        })}
      </FormGroup>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
